import { BridgeActionEnum } from "@/types/webview";
import { postWebviewMessage } from "./postWebviewMessage";

export const getMicrophoneStatus = () => {
  postWebviewMessage({
    action: BridgeActionEnum.GetMicrophoneStatus,
  });
};
